/**
 * Supabase table name constants (snake_case PostgreSQL table names)
 * Replaces src/services/firebase/collections.js
 */

export const TABLES = {
  USERS: 'users',
  CARETAKERS: 'caretakers',
  CLIENTS: 'clients',
  SHIFTS: 'shifts',
  APPOINTMENTS: 'appointments',
  CARE_REPORT_TEMPLATES: 'care_report_templates',
  CARE_REPORTS: 'care_reports',
  QUICKBOOKS_TOKENS: 'quickbooks_tokens'
};
